const getPercentage = (completedTasks, totalTasks) => {
  if (!totalTasks) return 0;
  return Math.min(100, Math.round((completedTasks / totalTasks) * 100));
};

const getProgressSummary = (status, percentage) => {
  if (status === "Completed") return "Delivered";
  if (status === "At Risk") return "Needs Attention";
  if (percentage >= 75) return "Healthy";
  if (percentage >= 40) return "Steady";
  return "Early Stage";
};

export const mapProjectRecord = (record) => {
  const totalRecruitsCount = Number(record.totalRecruitsCount ?? record.completedTasks ?? 0);
  const percentage = getPercentage(totalRecruitsCount, record.totalTasks);

  return {
    projectId: record.id,
    backendId: record.backendId ?? null,
    projectName: record.name,
    projectType: record.type,
    status: record.status,
    progressSummary: getProgressSummary(record.status, percentage),
    completedTasks: totalRecruitsCount,
    totalRecruitsCount,
    totalTasks: record.totalTasks,
    percentage,
    priority: record.priority,
    targets: record.targets,
    startDate: record.startDate,
    dueDate: record.dueDate,
    assignedUsers: record.assignedUsers,
    notes: record.notes || "",
  };
};

// Normalises a raw `/projects` API row into the record shape `mapProjectRecord` expects.
export const mapApiProjectToRecord = (project) => {
  const totalTargets = Number(project?.targets) || 0;
  const recruitedCount = Number(
    project?.totalRecruitsCount ??
      project?.progress?.recruitedCount ??
      project?.recruitedCount ??
      0,
  );
  const backendId = Number(project?.id);

  return {
    id:
      project?.projectCode ||
      (Number.isFinite(backendId) ? `PRJ-${backendId}` : ""),
    backendId: Number.isFinite(backendId) ? backendId : null,
    name: project?.projectName || "Untitled Project",
    type: project?.ProjectType?.name || project?.projectType || "General",
    status: project?.status || "Planned",
    priority: project?.priority,
    completedTasks: recruitedCount,
    totalRecruitsCount: recruitedCount,
    totalTasks: totalTargets,
    targets: totalTargets,
    startDate: project?.startDate || "",
    dueDate: project?.dueDate || "",
    assignedUsers: Array.isArray(project?.assignees)
      ? project.assignees.map((assignee) => assignee?.email).filter(Boolean)
      : [],
    notes: project?.notes || "",
  };
};
